/**
 * Timing for offline mode: the browser holds every question and sends its queued answers in one batch every
 * `baseSeconds`, at a random moment per participant so that thousands of browsers never arrive together.
 */

/** Delay before the very first batch: spread over the first interval, so a class that logs in at once does not sync at once. */
export function firstSyncDelayMs(baseSeconds: number, random: () => number = Math.random): number {
  return Math.round(baseSeconds * 1000 * (0.25 + 0.75 * random()))
}

/** Delay between batches: the interval plus or minus a third. */
export function nextSyncDelayMs(baseSeconds: number, random: () => number = Math.random): number {
  return Math.round(baseSeconds * 1000 * (0.67 + 0.66 * random()))
}

/** Key under which "the participant pressed finish" survives a reload while the server cannot be reached. */
export function finishedStorageKey(draftKey: string): string {
  return `${draftKey}/finished`
}
